import Vue from 'vue';
import Loading from '../components/Loading.vue';
const LoadingConstructor = Vue.extend(Loading);

export default  function (propsData) {
    const loading = new LoadingConstructor({
        el: document.createElement('div'),
        propsData:propsData
    })

    // new一个对象，然后插入body里面
    document.body.appendChild(loading.$el);

    const close = loading.close;
    loading.close = function () {
        close();

        loading.$nextTick( ()=> {
            console.log('销毁');
            loading.$destroy();
        })
    }

    return loading;
}
